import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import { ListPendingPage, ListStockPage } from 'pages/Stock';

const stockRoutes = ({
  isLoggedIn,
  location,
}: RouterProps): RouteObject => ({
  path: 'estoque',
  element: isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: 'saldo-estoque/',
      element: <ListStockPage />,
    },
    {
      path: 'pendentes-regularizacao/',
      element: <ListPendingPage />,
    },
  ],
});

export default stockRoutes;